<app-service-detail>
  <div class="row w-100 m-0 position-relative">
      <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
      </app-variables-tabs>
    <app-list-grid
      *ngIf="!hideList"
      [items]="serviceLocations"
      [determinantMapById]="determinantMapById"
      [baseUrl]="baseUrl"
      [toggleIcons]="false"
      [navigationEdit]="false"
      [expanded]="true"
      (updateFunction)="updateServiceLocation($event)"
      (deleteFunction)="deleteServiceLocation($event)"
      (editFunction)="loadServiceLocation($event)"
      (filterBy)="onNewFilterBy($event)"
      class="col-md-12 px-md-5 ml-auto"
      headingText="Collection places available in the service"
      createNewText1Part="Select an existing cost or click on"
      createNewText2Part="to create a new cost"
    >
      <a
        (click)="loadServiceLocation(false)"
        placement="left"
        aria-hidden="true"
        class="btn list-search-add"
        >{{ 'Add' | translate }}</a
      >
    </app-list-grid>

    <div
      *ngIf="showEdit || showAdd"
      class="layer half-layer col px-3"
      [ngStyle]="style"
      mwlResizable
      [enableGhostResize]="true"
      [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
      (resizeEnd)="onResizeEnd($event)"
      style="min-height:calc(100vh - 9.1rem);"
    >
      <service-location-edit
        [serviceLocation]="serviceLocation"
        [serviceId]="serviceId"
        [determinantMapById]="determinantMapById"
        (formSubmit)="closeSlider()"
        (editCancel)="closeLayers()"
        class="w-100"
      ></service-location-edit>
    </div>
    <div class="shadow"></div>
    <div class="col">
      <tab-menu
        *ngIf="hideList"
        [items]="serviceLocations"
        [baseUrl]="baseUrl"
      ></tab-menu>
      <ng-content></ng-content>
    </div>
  </div>
</app-service-detail>
